<template>
  <standard-dialog
    v-model="model"
    :title="editedItem.id ? $t('change_grocery') : $t('new_grocery')"
    icon="mdi-food-apple-outline"
    @save="save"
    :disabled="!valid || loading"
    :loading="loading"
  >
    <v-container>
      <v-form v-model="valid">
        <v-row>
          <v-col cols="12">
            <text-field
              v-model="editedItem.name"
              :label="$t('title')"
              :rules="[rules.required]"
              required
            ></text-field>
          </v-col>
          <v-row class="px-3">
            <v-col cols="6">
              <text-field
                v-model="editedItem.code"
                :label="$t('item_code')"
                :rules="[rules.required]"
                required
              ></text-field>
            </v-col>
            <v-col cols="6">
              <autocomplete
                v-model="editedItem.measure"
                required
                :items="[
                  { code: 1, name: 'kg' },
                  { code: 2, name: 'l' },
                  { code: 3, name: 'kom' },
                ]"
                :label="$t('unit_of_measurment')"
                :rules="[rules.required]"
                item-value="name"
                item-text="name"
              ></autocomplete>
            </v-col>
          </v-row>
          <v-row class="px-3">
            <v-col cols="6">
              <text-field
                type="number"
                v-model="editedItem.price"
                :label="$t('price')"
                :rules="[rules.required]"
                required
              ></text-field>
            </v-col>
            <v-col cols="6">
              <text-field
                type="number"
                v-model="editedItem.min_quantity"
                :label="$t('minimal_qty')"
                :hint="$t('minimum_stock_hint')"
                persistent-hint
              ></text-field>
            </v-col>
          </v-row>
        </v-row>
      </v-form>
    </v-container>
  </standard-dialog>
</template>

<script>
import StandardDialog from "@/components/dialogs/StandardDialog.vue";
import { defaultGrocery } from "@/models/food";
import hasModel from "@/mixins/hasModel";
import hasValidation from "@/mixins/hasValidation";
import hasSnackbar from "@/mixins/hasSnackbar";
import groceryService from "@/services/grocery";

export default {
  name: "GroceryDialog",
  mixins: [hasModel, hasValidation, hasSnackbar],
  components: {
    StandardDialog,
  },
  props: {
    editedItem: {
      type: Object,
      required: true,
      default: () => ({ ...defaultGrocery }),
    },
  },
  data: () => ({
    loading: false,
  }),
  methods: {
    close() {
      this.editedItem = { ...defaultGrocery };
      this.model = false;
    },
    save() {
      this.editedItem.parent_id = this.editedItem.parent ? this.editedItem.parent.id : 0;
      if (this.editedItem.id) {
        this.updateGrocery();
      } else {
        this.createGrocery();
      }
    },
    updateGrocery() {
      this.loading = true;
      this.handleRequest(
        groceryService.updateGrocery(this.editedItem.id, this.editedItem),
        {
          successMessage: this.$t("ingredient_updated"),
          errorMessagePrefix: this.$t("error") + ": " || "Error: ",
        }
      )
        .then((res) => {
          this.$emit("groceryUpdated", res.data);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    createGrocery() {
      this.loading = true;
      this.handleRequest(groceryService.createGrocery(this.editedItem), {
        successMessage: this.$t("ingredient_created"),
        errorMessagePrefix: this.$t("error") + ": " || "Error: ",
      })
        .then((res) => {
          this.$emit("groceryCreated", res.data);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
